import { render, staticRenderFns } from "./CertificationsTab.vue?vue&type=template&id=0facc88c&"
import script from "./CertificationsTab.vue?vue&type=script&lang=js&"
export * from "./CertificationsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports